"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
// serves as a marker to utlize the same logic for the date itself
var badDate = new Date('not a date');
function isoDateStringOr(root, path, decorators, orElse) {
    if (path === void 0) { path = ''; }
    if (decorators === void 0) { decorators = []; }
    if (orElse === void 0) { orElse = ''; }
    return [].concat(_1.dateOr(root, path, decorators, badDate)).map(function (date) {
        return (date === badDate) ? orElse : date.toISOString();
    }).shift();
}
exports.isoDateStringOr = isoDateStringOr;
//# sourceMappingURL=isoDateStringOr.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/get-or/dist/getters/isoDateStringOr.js
 ** module id = 2474
 ** module chunks = 0
 **/